async function copyByClipboardAPI(text) {
    if (typeof navigator === 'undefined' || !navigator.clipboard) {
        throw new Error('Clipboard API is not supported in this environment.')
    }

    try {
        await navigator.clipboard.writeText(text)
    } catch (error) {
        if (error.name === 'NotAllowedError') {
            throw new Error('Permission denied: please allow clipboard access in browser settings.')
        }
        throw new Error(`Clipboard API failed: ${error.message}`)
    }
}

async function copyByExecCommand(text) {
    if (typeof document === 'undefined') {
        throw new Error('document.execCommand is not supported in this environment.')
    }

    return new Promise((resolve, reject) => {
        try {
            const textarea = document.createElement('textarea')
            textarea.value = text
            textarea.style.position = 'fixed' // 防止页面滚动
            textarea.style.opacity = '0'
            textarea.style.left = '-9999px'
            textarea.style.top = '-9999px'

            document.body.appendChild(textarea)

            // iOS 兼容：必须手动选中范围
            textarea.focus()
            textarea.select()

            const success = document.execCommand('copy')
            document.body.removeChild(textarea)

            if (success) {
                resolve()
            } else {
                reject(new Error('execCommand copy failed.'))
            }
        } catch (error) {
            reject(new Error(`execCommand exception: ${error.message}`))
        }
    })
}

globalThis.copyToClipboard = async function (text) {
    if (typeof text !== 'string') {
        throw new TypeError('copyToClipboard requires a string argument.')
    }

    // 优先 Clipboard API
    try {
        await copyByClipboardAPI(text)
        return
    } catch {
        // 忽略，进入兼容方案
    }

    // 回退 execCommand
    try {
        await copyByExecCommand(text)
        return
    } catch {
        throw new Error('Copy failed: Clipboard API and execCommand are both unsupported.')
    }
}
